import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpService } from '../../..';
import { executeApiRequest } from '../../../utils/asyncUtils';
import { IInventory } from '../inventoryInterfaces';

export const fetchInventory = createAsyncThunk('inventory/fetch', (itemId: string) =>
  executeApiRequest<IInventory[]>(() => httpService.get(`/Inventory/${itemId}`))
);
